
const getDayFormatted = () => {
    /*
        returns: dict, 
            { 
                "formal": str, e.g. 02 May, 2025,
                "numberHyphen": str, yyyy-mm-dd e.g. 2025-05-02
            }
    */

    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();

    const months = {
        '01':'January',
        '02': 'Febuary',
        '03': 'March',
        '04': 'April',
        '05': 'May',
        '06': 'June',
        '07': 'July',
        '08': 'August',
        '09': 'September',
        '10': 'October',
        '11': 'November',
        '12': 'December'
    }

    return {
        "formal": dd + ' ' + months[mm] + ', ' + yyyy,
        "numberHyphen": yyyy + '-' + mm + '-' + dd
    }
}

export default getDayFormatted;